import { FlatTreeControl } from '@angular/cdk/tree';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { ActivationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Navigate } from '@ngxs/router-plugin';
import { Actions, Select, Store, ofActionDispatched } from '@ngxs/store';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { IChoosenFilterEntity, IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';
import { AllUsersApiService } from 'app/library/all-users/services/all-users.api-service';
import { AllUsersService } from 'app/library/all-users/services/all-users.service';
import { IManageAudienceUserActionPayload } from 'app/library/audience-users/interfaces/audience-user-action.action-payload.interface';
import { IManageAudienceUsersActionPayload } from 'app/library/audience-users/interfaces/audience-users-action.action-payload.interface';
import { AudienceUsersService } from 'app/library/audience-users/services/audience-users.service';
import { AudienceService } from 'app/library/audience/services/audience.service';
import { CertificateRecordStatusEnum } from 'app/library/certificate-record/enums/certificate-record-status.enum';
import { CertificateRecord } from 'app/library/certificate-record/models/certificate-record';
import { CertificateRecordStatus } from 'app/library/certificate-record/models/certificate-record-status.model';
import { CertificateRecordApiService } from 'app/library/certificate-record/services/certificate-record.api-service';
import { CertificateRecordService } from 'app/library/certificate-record/services/certificate-record.service';
import { CertificationProviderSearchInterface } from 'app/library/certification-provider/interfaces/certification-provider-search.interface';
import { CertificationProvider } from 'app/library/certification-provider/models/certification-provider';
import { CertificationProvidersState } from 'app/library/certification-provider/models/certification-providers.state';
import { CertificationProviderService } from 'app/library/certification-provider/services/certification-provider.service';
import { AddCertificateDialogComponent } from 'app/library/certifications/components/dialogs/add-certificate-dialog/add-certificate-dialog.component';
import { AddCertificateUserProfileDialogComponent } from 'app/library/certifications/components/dialogs/add-certificate-user-profile-dialog/add-certificate-user-profile-dialog.component';
import { EditCertificateDialogComponent } from 'app/library/certifications/components/dialogs/edit-certificate-dialog/edit-certificate-dialog.component';
import { Certification } from 'app/library/certifications/models/certification';
import { AdminPermissions } from 'app/library/feature/enums/admin-permissions.enum';
import { GrowMoveAudienceMembersDialogComponent } from 'app/library/grow/dialogs/grow-move-audience-members-dialog/grow-move-audience-members-dialog.component';
import { ModuleCertificateService } from 'app/library/module-certificate/services/module-certificate.service';
import {
    AddUsersToModulesAsManagers,
    AddUsersToModulesAsManagersSuccess,
    AddUsersToModulesAsParticipantsAsync,
    AddUsersToModulesAsParticipantsAsyncSuccess,
    UpdateModuleUserResponsible,
    UpdateModuleUserResponsibleSuccess,
} from 'app/library/module-user/actions';
import { TakeOverUsersToModulesDialogComponent } from 'app/library/module/components/dialogs/take-over-users-to-modules/take-over-users-to-modules.component';
import { Module } from 'app/library/module/models/module.model';
import { JobStatus } from 'app/library/shared/async-job-drawer/enums/job-status.enum';
import { TeamCertificationParentNameEnum } from 'app/library/team/enums/team-certification-dialog-type.enum';
import { SnackBarTime } from 'app/projects/core/src/lib/constants/snack-bar';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { FUSE_ASYNC_DRAWER } from 'app/projects/fuse/src/lib/services/async-drawer.token';
import { MaxBrainConfirmDialogComponent } from 'app/projects/shared/src/lib/components/dialogs/confirm/confirm.component';
import { ScheduleSubjectTextDialogComponent } from 'app/projects/shared/src/lib/components/dialogs/schedule-subject-text/schedule-subject-text.component';
import { ScheduleDialogType } from 'app/projects/shared/src/lib/enums/schedule-dialog-type.enum';
import { PageSizePreferenceService } from 'app/projects/shared/src/lib/services/page-size-preference.service';
import { User } from 'app/projects/user/src/lib/models/user';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { AsyncJobApiService } from 'app/services/async-job.api-service';
import { TinymceService } from 'app/services/tinymce.service';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, take, takeUntil } from 'rxjs/operators';
import { CertificatesFilterByDialogComponent } from '../dialogs/certificates-filter-by-dialog/certificates-filter-by-dialog.component';
import { ReplaceCertificateDialogComponent } from '../dialogs/replace-certificate-dialog/replace-certificate-dialog.component';

const CERTIFICATES_FILTERS_LIST_STORAGE_KEY = 'certificatesFiltersList';

export interface CertificationFlatNode {
    id: string;
    expandable: boolean;
    provider: string;
    certificationName: string;
    avatarUrl: string;
    name: string;
    certificateFullName: string;
    status: string;
    statusValue: number;
    issueDate: Moment;
    expirationDate: Moment;
    level: number;
    isModuleCertificate: boolean;
    filename: string;
    isCertificationTargetMet: boolean;
    certificatesCount: number;
    targetCount: number;
    ownerId: string;
}

@Component({
    selector: 'app-providers-all-list',
    templateUrl: './providers-all-list.component.html',
    styleUrls: ['./providers-all-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ProvidersAllListComponent extends UnsubscribeOnDestroy implements OnInit, AfterViewInit {
    @Input()
    certificationProvidersTotalCount$: Observable<number>;

    @Input()
    userIds$: Observable<number[]>;
    userIds: number[];

    @Input()
    allUser$: Observable<User[]>;

    @Input()
    allUserTotalCount$: Observable<number>;

    @Input()
    selectedCertificationIds$: Observable<string[]>;

    @Input()
    displayedColumns: string[];

    @Input()
    canUserManageCertificates: boolean = false;

    @Input()
    isViewOnly: boolean = false;

    @Input()
    teamId: string;

    @Input()
    subteamCount: number;

    @Input()
    isTrackSubTeamProgressActive: boolean;

    @Input()
    userId: string;

    @Input()
    parentType: TeamCertificationParentNameEnum;

    @Input()
    certificateToBeReplaced: CertificationFlatNode;

    @Input()
    sessionStorageListPageSize: string;

    @Output()
    onSelectCertificate = new EventEmitter<CertificationFlatNode>();

    @Select(CertificationProvidersState.getFilteredEntities)
    certificationProviders$: Observable<CertificationProvider[]>;

    get isAddCertificateBtnVisible(): boolean {
        if (this.profile.id === this.userId) {
            return true;
        }

        return (
            this.profile.permissions.includes(AdminPermissions.TENANT_MANAGEMENT) ||
            (this.profile.permissions.includes(AdminPermissions.CERTIFICATION_WRITE) &&
                (this.profile.permissions.includes(AdminPermissions.USERS_READ) || this.profile.permissions.includes(AdminPermissions.USERS_WRITE)))
        );
    }

    get hasTenantAdminOrEditCertificatePermission(): boolean {
        if (this.profile.id === this.userId) {
            return true;
        }

        return this.profile.permissions.includes(AdminPermissions.CERTIFICATION_WRITE) || this.profile.permissions.includes(AdminPermissions.TENANT_MANAGEMENT);
    }

    get hasTenantAdminOrEditGrowPermission(): boolean {
        return this.profile.permissions.includes(AdminPermissions.GROW_WRITE) || this.profile.permissions.includes(AdminPermissions.TENANT_MANAGEMENT);
    }

    get hasTenantAdminOrUsersReadPermission(): boolean {
        return this.profile.permissions.includes(AdminPermissions.USERS_READ) || this.profile.permissions.includes(AdminPermissions.TENANT_MANAGEMENT);
    }

    get hasNoUsers(): boolean {
        return !this.userIds?.length;
    }

    profile = this._store.selectSnapshot(UserState.getMyInfo);

    isFilterByExpiringChecked: boolean = false;
    isFilterByRecentlyExpiredChecked: boolean = false;
    isUserDetailsCardHidden: boolean = false;
    isLoading: boolean = false;
    isFilterOrSearchActive: boolean = false;
    isUserTenantAdmin: boolean = false;

    subteamsProgressToggle = new FormControl(false);

    certificatesStatuses = CertificateRecordStatus.all;
    CertificateRecordStatusEnum = CertificateRecordStatusEnum;
    certificationsFilterValues: Certification[];
    TeamCertificationParentNameEnum = TeamCertificationParentNameEnum;

    selectedCertificationIds: string[] = [];
    selectedCertificationProviderIds: string[] = [];
    selectedCertificationStatusIds: number[] = [];
    selectedCertificationTeamIds: string[] = [];
    selectedCertificationExcludedTeamIds: string[] = [];
    selectedCertificationUserIds: string[] = [];

    statusInput = new FormControl(sessionStorage.getItem('certificationsStatusFilter') ? JSON.parse(sessionStorage.getItem('certificationsStatusFilter')) : []);
    searchInput = new FormControl(this._store.selectSnapshot(CertificationProvidersState).searchTerm);
    confirmDialogRef: MatDialogRef<MaxBrainConfirmDialogComponent>;
    filterByDialogRef: MatDialogRef<CertificatesFilterByDialogComponent>;
    private _isFilterDialogOpen = false;
    selectedCertificate: CertificationFlatNode;

    issueDateBefore: Moment;
    issueDateAfter: Moment;
    expirationDateBefore: Moment;
    expirationDateAfter: Moment;
    filterIssueDateActive: boolean = false;
    filterExpirationDateActive: boolean = false;
    filterCertificationsActive: boolean = false;
    selectedCertificates: any[] = [];
    isDownloadButtonVisible: boolean = false;

    filtersList: any[] = [];
    checkboxes = {};
    selectedUserIds: string[] = [];

    @ViewChild(MatPaginator)
    paginator: MatPaginator;
    pageSize: number;

    get checkboxCount(): number {
        return Object.values(this.checkboxes).filter((value) => value === true).length;
    }

    private transformer = (node: CertificationProvider | Certification | CertificateRecord, level: number): CertificationFlatNode => {
        if ((node as CertificationProvider).providerName) {
            // This is a CertificationProvider node
            return {
                id: (node as CertificationProvider).id,
                expandable: !!(node as CertificationProvider).certifications && (node as CertificationProvider).certifications.length > 0,
                provider: (node as CertificationProvider).providerName,
                certificationName: '',
                avatarUrl: '',
                name: '',
                certificateFullName: '',
                status: null,
                statusValue: null,
                issueDate: null,
                expirationDate: null,
                level: level,
                isModuleCertificate: null,
                filename: null,
                isCertificationTargetMet: (node as CertificationProvider).isCertificationTargetMet,
                certificatesCount: null,
                targetCount: null,
                ownerId: null,
            };
        } else if ((node as Certification).certificationName) {
            // This is a CertificationDetail node
            return {
                id: (node as Certification).id,
                expandable: !!(node as Certification).certificates && (node as Certification).certificates.length > 0,
                provider: '',
                certificationName: (node as Certification).certificationName,
                avatarUrl: '',
                name: '',
                certificateFullName: '',
                status: null,
                statusValue: null,
                issueDate: null,
                expirationDate: null,
                level: level,
                isModuleCertificate: null,
                filename: null,
                isCertificationTargetMet: null,
                certificatesCount: (node as Certification).certificatesCount,
                targetCount: (node as Certification).targetCount,
                ownerId: null,
            };
        } else {
            // This is a CertificateRecord node
            if (level === 2 && !((node as CertificateRecord).id in this.checkboxes)) {
                this.checkboxes[(node as CertificateRecord).id] = false;
            }

            return {
                id: (node as CertificateRecord).id,
                expandable: false,
                provider: '',
                certificationName: '',
                avatarUrl: (node as CertificateRecord).owner.avatar.src,
                name: (node as CertificateRecord).owner.fullName,
                certificateFullName: (node as CertificateRecord).name,
                status: this.certificatesStatuses[(node as CertificateRecord).officialCertificateMetadata.status].translationLabel,
                statusValue: this.certificatesStatuses[(node as CertificateRecord).officialCertificateMetadata.status].value,
                issueDate: (node as CertificateRecord).officialCertificateMetadata.issueDate,
                expirationDate: (node as CertificateRecord).officialCertificateMetadata.expirationDate,
                level: level,
                isModuleCertificate: !!(node as CertificateRecord).moduleUser?.id,
                filename: (node as CertificateRecord).filename,
                isCertificationTargetMet: null,
                certificatesCount: null,
                targetCount: null,
                ownerId: (node as CertificateRecord).owner.id,
            };
        }
    };

    treeControl = new FlatTreeControl<CertificationFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );

    treeFlattener = new MatTreeFlattener(
        this.transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => {
            if ((node as CertificationProvider).providerName) {
                return (node as CertificationProvider).certifications;
            } else if ((node as Certification).certificationName) {
                return (node as Certification).certificates;
            } else {
                return [];
            }
        }
    );

    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    private async _handleCertificatesFilters(
        selectedStatuses: IChoosenFilterEntity[],
        selectedIssueDate: IChoosenFilterInterface,
        selectedExpirationDate: IChoosenFilterInterface,
        selectedCertifications: IChoosenFilterInterface[],
        selectedProviders: IChoosenFilterInterface[],
        selectedTeams: IChoosenFilterInterface[],
        selectedUsers: IChoosenFilterInterface[]
    ): Promise<void> {
        this.statusesSelected(selectedStatuses);
        this.issueDateSelected(selectedIssueDate);
        this.expirationDateSelected(selectedExpirationDate);
        this.certificationsSelected(selectedCertifications);
        this.providersSelected(selectedProviders);
        this.teamsSelected(selectedTeams);
        this.usersSelected(selectedUsers);
    }

    private _restoreFiltersFromStorage(): void {
        const filters = this._allUsersApiService.getFiltersFromStorage(CERTIFICATES_FILTERS_LIST_STORAGE_KEY);

        if (!filters?.length) {
            return;
        }

        void this._handleCertificatesFilters(
            filters.filter((entity) => entity.entity.type === 'Status').map((ent) => ent.entity),
            filters.find((entity) => entity.entity.type === 'IssueDate'),
            filters.find((entity) => entity.entity.type === 'ExpirationDate'),
            filters.filter((entity) => entity.entity.type === 'certification'),
            filters.filter((entity) => entity.entity.type === 'provider'),
            filters.filter((entity) => entity.entity.type === 'Teams'),
            filters.filter((entity) => entity.entity.type === 'Users' || entity.entity.type === 'TeamMembers')
        );
    }

    private _handelSelectedCertificates(): void {
        this.selectedCertificates = [];
        this.selectedCertificates.push(...this.selectedCertificationIds, ...this.selectedCertificationProviderIds);

        if (this.selectedCertificates.length) {
            this.filterCertificationsActive = true;
        } else {
            this.filterCertificationsActive = false;
        }
    }

    certificatesStatistics: {
        totalCount: number;
        expiredCount: number;
        expiringCount: number;
    };

    constructor(
        @Inject(FUSE_ASYNC_DRAWER) public asyncJobService: AsyncJobApiService,
        private _store: Store,
        private _certificationProviderService: CertificationProviderService,
        private _matDialog: MatDialog,
        private _moduleCertificateService: ModuleCertificateService,
        private _translateService: TranslateService,
        private _allUsersService: AllUsersService,
        private _allUsersApiService: AllUsersApiService,
        private _certificateRecordService: CertificateRecordService,
        private _certificateRecordApiService: CertificateRecordApiService,
        private _router: Router,
        private _action$: Actions,
        private _matSnackBar: MatSnackBar,
        private _tinymceService: TinymceService,
        private _tenantDataService: TenantDataService,
        private _audienceService: AudienceService,
        private _audienceUsersService: AudienceUsersService,
        private _pageSizePreferenceService: PageSizePreferenceService
    ) {
        super();
    }

    ngOnInit(): void {
        this._allUsersApiService.setFiltersFromStorage(CERTIFICATES_FILTERS_LIST_STORAGE_KEY);
        this._restoreFiltersFromStorage();
        this.subteamsProgressToggle.setValue(this.isTrackSubTeamProgressActive);

        this.selectedCertificates.push(
            ...Array.from(new Set(JSON.parse(sessionStorage.getItem('certificationProvidersSelectedFilter')))),
            ...Array.from(new Set(JSON.parse(sessionStorage.getItem('certificationsSelectedFilter'))))
        );

        this.userIds$?.pipe(takeUntil(this._unsubscribeAll)).subscribe((userIds) => {
            this.userIds = userIds;
        });

        const pageSizeKey = this.sessionStorageListPageSize || 'certification-provider.providers-all-list';
        const legacySessionPageSize = parseInt(sessionStorage.getItem(this.sessionStorageListPageSize), 10);
        const preferredPageSize = this._pageSizePreferenceService.getPageSize(
            pageSizeKey,
            [10, 25, 50],
            Number.isFinite(legacySessionPageSize) && legacySessionPageSize > 0 ? legacySessionPageSize : 50
        );
        this.loadCertificationProvidersPage(false, preferredPageSize);

        this.treeControl.dataNodes
            ?.filter((node) => node.level === 2)
            .forEach((node) => {
                if (!(node.id in this.checkboxes)) {
                    this.checkboxes[node.id] = false;
                }
            });

        this.isDownloadButtonVisible =
            this.parentType === TeamCertificationParentNameEnum.Admin ||
            this.parentType === TeamCertificationParentNameEnum.Team ||
            this.parentType === TeamCertificationParentNameEnum.TeamMember;

        if (this.issueDateBefore || this.issueDateAfter) {
            this.filterIssueDateActive = true;
        }

        if (this.expirationDateBefore || this.expirationDateAfter) {
            this.filterExpirationDateActive = true;
        }

        if (this.selectedCertificates?.length) {
            this.filterCertificationsActive = true;
        }

        this._allUsersApiService.filtersList$.pipe(takeUntil(this._unsubscribeAll)).subscribe((filters) => {
            if (this._isFilterDialogOpen) {
                return;
            }

            this.filtersList = filters;
        });
    }

    ngAfterViewInit() {
        this.paginator.page.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            this.loadCertificationProvidersPage(false);
        });

        const pageSizeKey = this.sessionStorageListPageSize || 'certification-provider.providers-all-list';
        const legacySessionPageSize = parseInt(sessionStorage.getItem(this.sessionStorageListPageSize), 10);
        this.pageSize = this._pageSizePreferenceService.getPageSize(
            pageSizeKey,
            [10, 25, 50],
            Number.isFinite(legacySessionPageSize) && legacySessionPageSize > 0 ? legacySessionPageSize : 50
        );

        this.searchInput.valueChanges.pipe(takeUntil(this._unsubscribeAll), debounceTime(1000), distinctUntilChanged()).subscribe((searchText) => {
            this.loadCertificationProvidersPage(true);
        });

        this.statusInput.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
            this.loadCertificationProvidersPage(true);
        });
    }

    statusesSelected(statuses: IChoosenFilterEntity[]): void {
        if (statuses?.length) {
            this.selectedCertificationStatusIds = statuses.map((status) => parseInt(status.id));
        } else {
            this.selectedCertificationStatusIds = [];
        }
    }

    issueDateSelected(issueDate: IChoosenFilterInterface): void {
        if (issueDate) {
            this.filterIssueDateActive = true;
            this.issueDateBefore = moment(issueDate.rangeValue2);
            this.issueDateAfter = moment(issueDate.rangeValue1);
        } else {
            this.issueDateBefore = null;
            this.issueDateAfter = null;
        }
    }

    expirationDateSelected(expirationDate: IChoosenFilterInterface): void {
        if (expirationDate) {
            this.filterExpirationDateActive = true;
            this.expirationDateBefore = moment(expirationDate.rangeValue2);
            this.expirationDateAfter = moment(expirationDate.rangeValue1);
        } else {
            this.expirationDateBefore = null;
            this.expirationDateAfter = null;
        }
    }

    certificationsSelected(certifications: IChoosenFilterInterface[]): void {
        if (certifications?.length) {
            this.selectedCertificationIds = certifications.map((certification) => certification.entity.id);
        } else {
            this.selectedCertificationIds = [];
        }

        this._handelSelectedCertificates();
    }

    providersSelected(providers: IChoosenFilterInterface[]): void {
        if (providers?.length) {
            this.selectedCertificationProviderIds = providers.map((provider) => provider.entity.id);
        } else {
            this.selectedCertificationProviderIds = [];
        }

        this._handelSelectedCertificates();
    }

    teamsSelected(teams: IChoosenFilterInterface[]): void {
        if (teams?.length) {
            this.selectedCertificationTeamIds = teams.map((team) => team.entity.id);
            this.selectedCertificationExcludedTeamIds = teams.reduce<string[]>((acc, team) => [...acc, ...(team.entity.excludedTeamIds || [])], []);
            this.selectedCertificationExcludedTeamIds = Array.from(new Set(this.selectedCertificationExcludedTeamIds));
        } else {
            this.selectedCertificationTeamIds = [];
            this.selectedCertificationExcludedTeamIds = [];
        }

        this._handelSelectedCertificates();
    }

    usersSelected(users: IChoosenFilterInterface[]): void {
        if (users?.length) {
            this.selectedCertificationUserIds = users.map((user) => user.entity.id);
        } else {
            this.selectedCertificationUserIds = [];
        }

        this._handelSelectedCertificates();
    }

    openAddCertificateDialog(): void {
        if (
            this.parentType === TeamCertificationParentNameEnum.Profile ||
            this.parentType === TeamCertificationParentNameEnum.UserProfile ||
            this.parentType === TeamCertificationParentNameEnum.TeamMember
        ) {
            this.openAddUserProfileCertificateDialog();
        } else {
            this.openAddCertificateDefaultDialog();
        }
    }

    openAddUserProfileCertificateDialog(): void {
        const dialogRef = this._matDialog.open(AddCertificateUserProfileDialogComponent, {
            width: '1100px',
            panelClass: 'full-screen-modal',
            autoFocus: false,
        });

        dialogRef.componentInstance.title = 'PAGE.CERTIFICATE.BUTTON.ADD';
        dialogRef.componentInstance.userId = this.userId;

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.loadCertificationProvidersPage();
            }
        });
    }

    openAddCertificateDefaultDialog(): void {
        let dataType: string;

        if (
            this.parentType === TeamCertificationParentNameEnum.Admin ||
            (this.parentType === TeamCertificationParentNameEnum.Replace && this._router.url === '/admin/people-development/certifications/all')
        ) {
            this._allUsersService.fetchAllUsers([], '', '', '', '', 5, 1, undefined, '', false, [], [], [], [], false, false, false, [], [], ['active']);
            dataType = 'users';
        } else if (this.parentType === TeamCertificationParentNameEnum.Team) {
            this._allUsersService.fetchTeamMembersUsers(this.teamId, '', '', '', 5, 1, this.subteamsProgressToggle.value);
            dataType = 'teamMembersUsers';
        }

        const dialogRef = this._matDialog.open(AddCertificateDialogComponent, {
            width: '1100px',
        });

        dialogRef.componentInstance.entitie$ = this.allUser$;
        dialogRef.componentInstance.title = 'PAGE.CERTIFICATIONS.BUTTON.ADD';
        dialogRef.componentInstance.totalCount$ = this.allUserTotalCount$;
        dialogRef.componentInstance.dataType = dataType;
        dialogRef.componentInstance.teamId = this.teamId;
        dialogRef.componentInstance.includeSubteams = this.subteamsProgressToggle.value;

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.loadCertificationProvidersPage();
            }
        });
    }

    async openAddReplaceCertificateDefaultDialog(certificate: CertificationFlatNode): Promise<void> {
        await this._certificateRecordService.fetchCertificateRecord(certificate.id);
        const certificateRecord = this._certificateRecordService.getCertificateRecord();

        const dialogRef = this._matDialog.open(AddCertificateUserProfileDialogComponent, {
            width: '1100px',
            panelClass: 'full-screen-modal',
            autoFocus: false,
        });

        dialogRef.componentInstance.title = 'PAGE.CERTIFICATE.BUTTON.ADD';
        dialogRef.componentInstance.userId = this.userId;
        dialogRef.componentInstance.providerId = certificateRecord.officialCertificateMetadata.certification.provider.id;
        dialogRef.componentInstance.certificationId = certificateRecord.officialCertificateMetadata.certification.id;
        dialogRef.componentInstance.certificate = certificate;
        dialogRef.componentInstance.userId = certificate.ownerId;
        dialogRef.componentInstance.minIssueDate = certificate.issueDate;

        dialogRef.componentInstance.onReplaced.subscribe((result: boolean) => {
            if (result) {
                this.loadCertificationProvidersPage();
            }
        });

        dialogRef.afterClosed().subscribe(async (newCertificate: CertificateRecord) => {
            if (newCertificate) {
                await this._certificationProviderService.replaceCertificate(certificate.id, newCertificate.id);

                this.loadCertificationProvidersPage();
            }
        });
    }

    async openEditCertificateDialog(certificate: CertificationFlatNode): Promise<void> {
        if (this.parentType === TeamCertificationParentNameEnum.Profile) {
            this._router.navigate(['/profile/tab/certificates', { outlets: { modal: ['certificate', certificate.id] } }]);

            this._router.events
                .pipe(
                    filter((event) => event instanceof ActivationEnd),
                    takeUntil(this._unsubscribeAll)
                )
                .subscribe((event: ActivationEnd) => {
                    if (event.snapshot.queryParamMap.get('result') === 'true') {
                        this.loadCertificationProvidersPage();
                    }
                });
        } else if (this.parentType === TeamCertificationParentNameEnum.UserProfile) {
            this._router.navigate([`/users/${this.userId}/edit/certificates`, { outlets: { modal: ['certificate', certificate.id] } }]);

            this._router.events
                .pipe(
                    filter((event) => event instanceof ActivationEnd),
                    takeUntil(this._unsubscribeAll)
                )
                .subscribe((event: ActivationEnd) => {
                    if (event.snapshot.queryParamMap.get('result') === 'true') {
                        this.loadCertificationProvidersPage();
                    }
                });
        } else {
            await this._certificateRecordService.fetchCertificateRecord(certificate.id);
            const certificateRecord = this._certificateRecordService.getCertificateRecord();

            const dialogRef = this._matDialog.open(EditCertificateDialogComponent, {
                width: '1100px',
                panelClass: 'full-screen-modal',
            });

            dialogRef.componentInstance.title = 'ALTERNATIVE.CERTIFICATE.SINGULAR';
            dialogRef.componentInstance.certificateRecord = certificateRecord;
            dialogRef.componentInstance.isViewOnly = !this.canUserManageCertificates || certificate.isModuleCertificate;

            dialogRef.afterClosed().subscribe((result: boolean) => {
                if (result) {
                    this.loadCertificationProvidersPage();
                }
            });
        }
    }

    downloadCertificate(certificate: CertificationFlatNode): void {
        this._certificateRecordService.downloadCertificate(certificate.id);
    }

    async openReplaceCertificateDialog(certificate: CertificationFlatNode): Promise<void> {
        const dialogRef = this._matDialog.open(ReplaceCertificateDialogComponent, {
            width: '976px',
        });

        dialogRef.componentInstance.certificateToBeReplaced = certificate;

        dialogRef.afterClosed().subscribe(async (result: { newSelectedCertificate: CertificationFlatNode }) => {
            if (result) {
                const success = await this._certificationProviderService.replaceCertificate(certificate.id, result.newSelectedCertificate.id);

                if (success) {
                    this.loadCertificationProvidersPage();
                }
            }
        });
    }

    removeCertificate(certificate: CertificationFlatNode): void {
        this.confirmDialogRef = this._matDialog.open(MaxBrainConfirmDialogComponent, {
            disableClose: false,
        });

        this.confirmDialogRef.componentInstance.confirmTitle = 'GENERAL.BUTTON.CONFIRM';
        this.confirmDialogRef.componentInstance.confirmButtonColor = 'warn';
        this.confirmDialogRef.componentInstance.actionButtonText = 'GENERAL.BUTTON.REMOVE';
        this.confirmDialogRef.componentInstance.confirmMessage = this._translateService.instant('PAGE.CERTIFICATIONS.MESSAGE.DELETE_CERTIFICATE', {
            userName: certificate.name,
            certificateName: certificate.certificateFullName,
        });

        this.confirmDialogRef.afterClosed().subscribe(async (result: boolean) => {
            if (result) {
                await this._moduleCertificateService.deleteCertificate(certificate.id);
                this.loadCertificationProvidersPage();
            }

            this.confirmDialogRef = null;
        });
    }

    async subteamsProgressToggleChanged(event: MatSlideToggleChange): Promise<void> {
        this.loadCertificationProvidersPage();
        this.subteamsProgressToggle.setValue(event.checked);
    }

    goToUserProfile(userId: string): void {
        this.isUserDetailsCardHidden = true;
        this._store.dispatch(new Navigate(['/users/' + userId + '/edit']));
    }

    toggleCertificateSelection(certificate?: CertificationFlatNode): void {
        if (certificate) {
            this.selectedCertificate = certificate;
            this.onSelectCertificate.emit(certificate);
        } else {
            this.selectedCertificate = null;
            this.onSelectCertificate.emit(null);
        }
    }

    downloadExcel(): void {
        const data: CertificationProviderSearchInterface = {
            statuses:
                this.parentType === TeamCertificationParentNameEnum.Profile || this.parentType === TeamCertificationParentNameEnum.UserProfile
                    ? this.statusInput.value || []
                    : this.selectedCertificationStatusIds,
            certificationsIds: this.selectedCertificationIds,
            certificationProvidersIds: this.selectedCertificationProviderIds,
            issueDateFrom: this.issueDateAfter,
            issueDateTo: this.issueDateBefore,
            expirationDateFrom: this.expirationDateAfter,
            expirationDateTo: this.expirationDateBefore,
            showExpiringOnly: this.isFilterByExpiringChecked,
            showRecentlyExpiredOnly: this.isFilterByRecentlyExpiredChecked,
            teamsIds: this.selectedCertificationTeamIds,
            excludedTeamIds: this.selectedCertificationExcludedTeamIds,
            userIds: this.selectedCertificationUserIds,
            includeSubteamsOfTeamsInFilter: true,
        };

        switch (this.parentType) {
            case TeamCertificationParentNameEnum.Admin:
                this._certificationProviderService.downloadCertificatesAdmin(this.paginator?.pageSize || 50, this.paginator?.pageIndex + 1 || 1, this.searchInput.value, data);
                break;
            case TeamCertificationParentNameEnum.Team:
                this._certificationProviderService.downloadCertificatesTeam(
                    this.paginator?.pageSize || 50,
                    this.paginator?.pageIndex + 1 || 1,
                    this.searchInput.value,
                    data,
                    this.teamId,
                    this.subteamsProgressToggle.value
                );
                break;
            case TeamCertificationParentNameEnum.TeamMember:
                this._certificationProviderService.downloadCertificatesTeamMember(
                    this.paginator?.pageSize || 50,
                    this.paginator?.pageIndex + 1 || 1,
                    this.searchInput.value,
                    data,
                    this.teamId,
                    this.userId
                );
                break;
        }
    }

    openFilterByDialog(): void {
        this._isFilterDialogOpen = true;
        this._allUsersApiService.setFiltersFromStorage(CERTIFICATES_FILTERS_LIST_STORAGE_KEY);

        this.filterByDialogRef = this._matDialog.open(CertificatesFilterByDialogComponent, {
            disableClose: true,
            width: '1100px',
            panelClass: 'filter-by-overflow-dialog',
        });

        this.filterByDialogRef.componentInstance.certificationProviders$ = this.certificationProviders$;
        this.filterByDialogRef.componentInstance.teamId = this.teamId;
        this.filterByDialogRef.componentInstance.includeSubteams = this.subteamsProgressToggle.value;

        this.filterByDialogRef.afterClosed().subscribe(async (result) => {
            this._isFilterDialogOpen = false;
            this._allUsersApiService.setFiltersFromStorage(CERTIFICATES_FILTERS_LIST_STORAGE_KEY);

            if (result && result.data) {
                await this._handleCertificatesFilters(
                    result.data.status,
                    result.data.issueDate,
                    result.data.expirationDate,
                    result.data.certifications,
                    result.data.providers,
                    result.data.teams,
                    result.data.users
                );

                this.loadCertificationProvidersPage(false);
            }

            this.filterByDialogRef = null;
        });
    }

    async clearFilters(): Promise<void> {
        this._allUsersApiService.setFiltersList(CERTIFICATES_FILTERS_LIST_STORAGE_KEY, [], true);
        await this._handleCertificatesFilters([], null, null, [], [], [], []);
        this.loadCertificationProvidersPage(false);
    }

    onSelectedChange(event: MatCheckboxChange, row: CertificationFlatNode): void {
        const certificateRecords = this.treeControl.dataNodes?.filter((node) => node.level === 2);

        if (event.checked) {
            if (!this.selectedUserIds.includes(row.ownerId)) {
                this.selectedUserIds.push(row.ownerId);
            }
        } else {
            const stillSelected = Object.keys(this.checkboxes).some(
                (certId) => this.checkboxes[certId] && certificateRecords.find((item) => item.id === certId)?.ownerId === row.ownerId
            );

            if (!stillSelected) {
                this.selectedUserIds = this.selectedUserIds.filter((id) => id !== row.ownerId);
            }
        }
    }

    subscribeToActionDispatched() {
        this._action$
            .pipe(ofActionDispatched(AddUsersToModulesAsParticipantsAsyncSuccess), take(1), takeUntil(this._unsubscribeAll))
            .subscribe(async (action: AddUsersToModulesAsParticipantsAsyncSuccess) => {
                const jobId = action.payload.asyncJobId;
                if (jobId) {
                    this.asyncJobService.getAllJobs(true);
                    this.asyncJobService.jobAdded.next(true);

                    // increases number of active async jobs on My backgrounds tasks button
                    this.asyncJobService.numberOfActiveAsyncJobs++;
                    let jobStatus = await this.asyncJobService.getJobStatus(jobId);

                    if (jobStatus.communicatedStatus === JobStatus.Finished || jobStatus.communicatedStatus === JobStatus.TimedOut) {
                        this.asyncJobService.getAllJobs(Boolean(localStorage.getItem('isDrawerOpen')));
                        this.asyncJobService.completedJobs++;
                    } else {
                        const intervalId = setInterval(async () => {
                            jobStatus = await this.asyncJobService.getJobStatus(jobId);
                            this.asyncJobService.jobStatus.next(jobStatus);

                            if (
                                jobStatus.communicatedStatus === JobStatus.Finished ||
                                jobStatus.communicatedStatus === JobStatus.TimedOut ||
                                jobStatus.communicatedStatus === JobStatus.Canceled
                            ) {
                                this.asyncJobService.getAllJobs(Boolean(localStorage.getItem('isDrawerOpen')));
                                this.asyncJobService.completedJobs++;

                                clearInterval(intervalId);
                            }
                        }, 3000);
                    }
                }
            });
    }

    takeOverSelected(): void {
        const dialogRef = this._matDialog.open(TakeOverUsersToModulesDialogComponent, {
            disableClose: false,
            width: '680px',
            autoFocus: false,
        });

        let userIds: string[];

        if (this.selectedUserIds.length) {
            userIds = this.selectedUserIds;
        } else {
            userIds = this.userIds.map((userId) => userId.toString());
        }

        dialogRef.componentInstance.filteredUserIds = userIds;
        dialogRef.componentInstance.title = this._translateService.instant('LIST.USER_MODULES.FIELD.CHOOSE_POSITION.TITLE', {
            usersCount: userIds.length,
        });

        dialogRef.afterClosed().subscribe(
            (result: {
                data: {
                    moduleList: Module[];
                    userRole: 'participant' | 'manager' | 'responsible';
                    permissions: string[];
                    roles: { user_id: string; role: string }[];
                };
            }) => {
                if (result && result.data) {
                    const actions = [];

                    if (result.data.userRole === 'participant') {
                        const action = new AddUsersToModulesAsParticipantsAsync({
                            moduleIds: result.data.moduleList.map((tempModule) => tempModule.id),
                            userIds: userIds,
                        });

                        actions.push(action);
                        this.subscribeToActionDispatched();
                    }

                    if (result.data.userRole === 'manager') {
                        const action = new AddUsersToModulesAsManagers({
                            moduleIds: result.data.moduleList.map((tempModule) => tempModule.id),
                            userIds: userIds,
                            permissions: result.data.permissions,
                        });
                        actions.push(action);
                    }

                    if (result.data.userRole === 'responsible') {
                        const action = new UpdateModuleUserResponsible({
                            moduleIds: result.data.moduleList.map((tempModule) => tempModule.id),
                            userIds: userIds,
                            roles: result.data.roles,
                        });
                        actions.push(action);
                    }

                    actions.forEach((action) => this._store.dispatch(action));

                    this._action$
                        .pipe(ofActionDispatched(AddUsersToModulesAsManagersSuccess, UpdateModuleUserResponsibleSuccess), take(1), takeUntil(this._unsubscribeAll))
                        .subscribe(() => {
                            const successMessage = this._translateService.instant('USER.MESSAGE.TAKE_OVER_SUCCESS', {
                                numberOfUsers: userIds.length,
                                numberOfModules: result.data.moduleList.length,
                            });

                            this._matSnackBar.open(successMessage, 'OK', {
                                verticalPosition: 'top',
                                duration: SnackBarTime.medium,
                            });
                        });
                }
            }
        );
    }

    async openNotifyDialog(notify: 'all' | 'selected', participantId?: string): Promise<void> {
        const dialogRef = this._matDialog.open(ScheduleSubjectTextDialogComponent, {
            width: '800px',
            disableClose: true,
        });

        const init: any = this._tinymceService.getInitConfiguration();
        const minNumberOfRows = 6;
        init.min_height = minNumberOfRows * 32 + 20;
        init.content_style = 'img { max-width: 100%; height: auto; }';

        dialogRef.componentInstance.init = init;
        dialogRef.componentInstance.dialogTitle = notify === 'all' ? 'GENERAL.BUTTON.NOTIFY_ALL' : 'GENERAL.BUTTON.NOTIFY_SELECTED';
        dialogRef.componentInstance.saveButtonText = 'GENERAL.BUTTON.SEND';
        dialogRef.componentInstance.actionNowText = 'GENERAL.BUTTON.SEND';
        dialogRef.componentInstance.urgentOptionText = 'GENERAL.LABEL.SEND_URGENTLY';
        dialogRef.componentInstance.subject = '';
        dialogRef.componentInstance.message = this._tenantDataService.tenantConfig?.certificate_notification?.default_text;
        dialogRef.componentInstance.dialogType = notify === 'all' ? ScheduleDialogType.NotifyAll : ScheduleDialogType.NotifySelected;
        dialogRef.componentInstance.isCertificateDialog = true;

        dialogRef.componentInstance.scheduleSubjectTextSaved.pipe(takeUntil(this._unsubscribeAll)).subscribe(async (data) => {
            let userIds: string[];

            if (this.selectedUserIds.length) {
                userIds = this.selectedUserIds;
            } else {
                userIds = this.userIds.map((userId) => userId.toString());
            }

            let successMessage = this._translateService.instant('GENERAL.MESSAGE.USERS_NOTIFIED');
            let success: string;

            try {
                if (this.parentType === TeamCertificationParentNameEnum.Team) {
                    success = await this._certificateRecordService.teamsNotifySelected(this.teamId, {
                        subject: data.subject,
                        message: data.message,
                        user_ids: userIds.map((userId) => parseInt(userId)),
                        is_urgent: data.isUrgent,
                    });
                } else {
                    success = await this._certificateRecordService.notifySelected({
                        subject: data.subject,
                        message: data.message,
                        user_ids: userIds.map((userId) => parseInt(userId)),
                        is_urgent: data.isUrgent,
                    });
                }
            } catch {
                dialogRef.componentInstance.isSaveInProgress = false;
                return;
            }

            if (success) {
                this._matSnackBar.open(successMessage, 'OK', {
                    verticalPosition: 'top',
                    duration: SnackBarTime.medium,
                });
            }

            dialogRef.close();
        });
    }

    async assignUsersToAudience(): Promise<void> {
        let audience = this._audienceService.getAudiences();
        if (!audience) {
            await this._audienceService.fetchAudiences();
            audience = this._audienceService.getAudiences();
        }
        const growMoveAudienceUsersDialogRef = this._matDialog.open(GrowMoveAudienceMembersDialogComponent, {
            disableClose: false,
            width: '600px',
        });

        let userIds: string[];

        if (this.selectedUserIds.length) {
            userIds = this.selectedUserIds;
        } else {
            userIds = this.userIds.map((userId) => userId.toString());
        }

        const audiences = this._audienceService.getAudiences();
        const audienceListTree = this._audienceService.convertListToTree(audiences);
        growMoveAudienceUsersDialogRef.componentInstance.title = 'ENGAGE.ALL_USERS_TAB.DIALOGS.ASSIGN_AUDIENCE.PLURAL';
        growMoveAudienceUsersDialogRef.componentInstance.label = 'ENGAGE.ALL_USERS_TAB.DIALOGS.ASSIGN_AUDIENCE.LABEL';
        growMoveAudienceUsersDialogRef.componentInstance.audienceListTree = audienceListTree[0];
        growMoveAudienceUsersDialogRef.componentInstance.selectedUserId$ = of(userIds);

        growMoveAudienceUsersDialogRef.afterClosed().subscribe(async (result: IManageAudienceUsersActionPayload) => {
            if (result) {
                const payload: IManageAudienceUserActionPayload = {
                    users: userIds.map((id) => {
                        return { id: id };
                    }) as [{ id: string }],
                    audiences: [{ id: result.target }],
                };

                const responsePayload = await this._audienceUsersService.addUsersToAudience(payload);
                if (responsePayload.asyncJobId) {
                    this._matSnackBar.open(this._translateService.instant('USER.MESSAGE.BULK_OPERATION_QUEUED'), 'OK', {
                        verticalPosition: 'top',
                        duration: SnackBarTime.slow,
                    });
                } else {
                    const newlyAssignedUsersLength = responsePayload.newlyAssigned.length;
                    const alreadyAssignedUsersLength = responsePayload.alreadyAssigned.length;
                    const alreadyInChildrenUsersLength = responsePayload.alreadyInChildren.length;
                    const successMessage = this._translateService.instant('ENGAGE.ALL_USERS_TAB.DIALOGS.ASSIGN_AUDIENCE.MESSAGE.ASSIGN_USERS_SUCCESS', {
                        newlyAssignedUsersLength,
                        alreadyAssignedUsersLength,
                        alreadyInChildrenUsersLength,
                    });
                    this._matSnackBar.open(successMessage, 'OK', {
                        verticalPosition: 'top',
                        duration: SnackBarTime.slow,
                    });
                }
            }
        });
    }

    async loadCertificationProvidersPage(resetPageIndex = false, pageSize = this.paginator?.pageSize): Promise<void> {
        this.isLoading = true;
        if (resetPageIndex) {
            this.paginator.pageIndex = 0;
        }

        const statusFilterLength =
            this.parentType === TeamCertificationParentNameEnum.Profile || this.parentType === TeamCertificationParentNameEnum.UserProfile
                ? this.statusInput.value?.length
                : this.selectedCertificationStatusIds.length;

        if (
            this.searchInput.value ||
            this.selectedCertificationIds.length ||
            this.selectedCertificationProviderIds.length ||
            statusFilterLength ||
            this.issueDateAfter ||
            this.issueDateBefore ||
            this.expirationDateAfter ||
            this.expirationDateBefore ||
            this.isFilterByExpiringChecked ||
            this.isFilterByRecentlyExpiredChecked ||
            this.selectedCertificationTeamIds.length ||
            this.selectedCertificationUserIds.length
        ) {
            this.isFilterOrSearchActive = true;
        }

        const data: CertificationProviderSearchInterface = {
            statuses:
                this.parentType === TeamCertificationParentNameEnum.Profile || this.parentType === TeamCertificationParentNameEnum.UserProfile
                    ? this.statusInput.value
                    : this.selectedCertificationStatusIds,
            certificationsIds: this.selectedCertificationIds,
            certificationProvidersIds: this.selectedCertificationProviderIds,
            issueDateFrom: this.issueDateAfter,
            issueDateTo: this.issueDateBefore,
            expirationDateFrom: this.expirationDateAfter,
            expirationDateTo: this.expirationDateBefore,
            showExpiringOnly: this.isFilterByExpiringChecked,
            showRecentlyExpiredOnly: this.isFilterByRecentlyExpiredChecked,
            teamsIds: this.selectedCertificationTeamIds,
            excludedTeamIds: this.selectedCertificationExcludedTeamIds,
            userIds: this.selectedCertificationUserIds,
            includeSubteamsOfTeamsInFilter: true,
        };

        switch (this.parentType) {
            case TeamCertificationParentNameEnum.Team:
                await this._certificationProviderService.fetchTeamCertificationProvidersSearch(
                    pageSize || 50,
                    this.paginator?.pageIndex + 1 || 1,
                    this.searchInput.value,
                    data,
                    this.teamId,
                    this.subteamsProgressToggle.value
                );

                this.certificatesStatistics = await this._certificateRecordApiService.getTeamCertificatesStatistics(
                    this.teamId,
                    pageSize || 50,
                    this.paginator?.pageIndex + 1 || 1,
                    this.searchInput.value,
                    data,
                    this.subteamsProgressToggle.value
                );
                break;
            case TeamCertificationParentNameEnum.TeamMember:
                await this._certificationProviderService.fetchTeamMemberCertificationProvidersSearch(
                    pageSize || 50,
                    this.paginator?.pageIndex + 1 || 1,
                    this.searchInput.value,
                    data,
                    this.userId
                );

                this.certificatesStatistics = await this._certificateRecordApiService.getUserCertificatesStatistics(
                    this.userId,
                    pageSize || 50,
                    this.paginator?.pageIndex + 1 || 1,
                    this.searchInput.value,
                    data
                );
                break;
            case TeamCertificationParentNameEnum.Profile:
            case TeamCertificationParentNameEnum.UserProfile:
                await this._certificationProviderService.fetchTeamMemberCertificationProvidersSearch(
                    pageSize || 50,
                    this.paginator?.pageIndex + 1 || 1,
                    this.searchInput.value,
                    data,
                    this.userId
                );
                break;
            case TeamCertificationParentNameEnum.Replace:
                await this._certificationProviderService.fetchCertificatesToReplace(pageSize || 50, this.paginator?.pageIndex + 1 || 1, this.certificateToBeReplaced.id);
                break;
            default:
                await this._certificationProviderService.fetchCertificationProvidersSearch(pageSize || 50, this.paginator?.pageIndex + 1 || 1, this.searchInput.value, data);

                this.certificatesStatistics = await this._certificateRecordApiService.getCertificatesStatistics(
                    pageSize || 50,
                    this.paginator?.pageIndex + 1 || 1,
                    this.searchInput.value,
                    data
                );
                break;
        }

        const certificationProviders = this._certificationProviderService.getCertificationProviders();

        this.dataSource.data = certificationProviders;
        this.certificationsFilterValues = certificationProviders.map((provider) => provider.certifications).reduce((acc, certifications) => acc.concat(certifications), []);
        // this.checkboxes = {};
        // this.selectedUserIds = [];

        setTimeout(() => {
            this.treeControl?.expandAll();
            this.isLoading = false;
        });
    }

    ngOnDestroy(): void {
        this._allUsersApiService.setFiltersList(null, [], false);
        super.ngOnDestroy();
    }
}
